class CollectionCategoryScroller extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-category-scroller]');
    this.previous = this.querySelector('[data-category-previous]');
    this.next = this.querySelector('[data-category-next]');
    if (!this.scroller) return;

    this.previous?.addEventListener('click', () => this.scrollBy(-1));
    this.next?.addEventListener('click', () => this.scrollBy(1));
    this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    this.updateButtons();
  }

  scrollBy(direction) {
    this.scroller.scrollBy({ left: direction * Math.max(220, this.scroller.clientWidth * 0.7), behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    if (this.previous) this.previous.disabled = this.scroller.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.scroller.scrollLeft >= maxScroll - 2;
  }
}

if (!customElements.get('collection-category-scroller')) {
  customElements.define('collection-category-scroller', CollectionCategoryScroller);
}
